
const stringify = obj => 
    Array.isArray(obj) ? 
        obj.sort().map(stringify).join(",")
        : typeof obj == "object" ?
            Object.entries(obj)
            .sort(([k1, ], [k2, ]) => k1 > k2 ? 1 : -1)
            .map(([k, v]) => k + "=" + stringify(v))
            .join(",")            
            : obj?.toString ? obj.toString() : ""


export default function requestCache() {
    const reqs: Record<string, Promise<any>> = {};
    function makeReq(req: () => Promise<unknown>, params: any, forceReload: bool = false) {
        const k = stringify(params);
        if(!(k in reqs) || forceReload)
            reqs[k] = req().then(res => {
                delete reqs[k];
                return res;
            });

        return reqs[k];
    }
    return {makeReq};
}
